const parseBool = (value: unknown): boolean => {
	if (typeof value === 'boolean') return value;
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		return ['true', '1', 'yes', 'on'].includes(normalized);
	}
	if (typeof value === 'number') return value !== 0;
	return !!value; // Fallback for other types
};
export default parseBool;
